import { useTranslation } from 'react-i18next';
import { topPerformerStar as aPlayerStar } from 'static/icons/resizable';
import { Button, Icon, Text } from 'view/atoms';
import * as S from './APlayerButton.styles';

type Props = {
  onClickHandler: () => void;
};

export const APlayerButton = ({ onClickHandler }: Props) => {
  const { t } = useTranslation();

  return (
    <S.Container>
      <Button kind='primary' onClick={onClickHandler}>
        <Icon
          src={aPlayerStar}
          alt='A-Player icon'
          style={{ marginRight: '8px' }}
        />
        <Text kind='body'>{t('aPlayerPage.title')}</Text>
      </Button>
    </S.Container>
  );
};
